import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { environment } from 'src/environments/environment';
import { DataService } from 'src/app/dashboard/_services/data.service';
import { StudentService } from '../../_services/student.service';
import { RequestsService } from '../../_services/requests.service';
import { SnackbarService } from 'src/app/_services/snackBar.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackBarErrorComponent } from 'src/app/components/snack-bar-error/snack-bar-error.component';
import { GlobalService } from 'src/app/_services/global.service';
import { TranslateService } from '@ngx-translate/core';
import 'moment-timezone';
import * as moment from 'moment';
import { ErrorMsgService } from 'src/app/shared/error-msg/error-msg.service';
import { Router } from '@angular/router';
declare var $: any;


@Component({
  selector: 'app-request-card',
  templateUrl: './request-card.component.html',
  styleUrls: ['./request-card.component.scss']
})
export class RequestCardComponent implements OnInit , OnDestroy {
  @Input("request") request;
  @Input("grades") grades;
  @Input("compactView") compactView;
  @Input("requestType") requestType;
  @Output() return = new EventEmitter();
  @Output() editCard = new EventEmitter();
  @Output() earlyDismissalRequest = new EventEmitter();

  editFlag = false;
  showFlag = true;
  foundError;
  gradeId;
  classId;
  name;
  classList;
  currLang;
  showEditModal = false;
  baseuUlr = environment.img_url;
  constructor(private studentService: StudentService,
    private requestsService: RequestsService,
    private _snackBar: MatSnackBar,
    private translate: TranslateService,
    private globalService: GlobalService,
    private errorMsgService: ErrorMsgService,
    private snackBar: SnackbarService,
    private router: Router,
    ) {
    this.globalService.getLang().subscribe(lng => {
      this.currLang = lng;
      this.translate.use(this.currLang);
    })
  }

  ngOnInit(): void {
    this.globalService.getLang().subscribe(lng => {
      this.currLang = lng;
      this.translate.use(this.currLang);
    })
    this.name = this.request.name;

    $('.modal').modal('hide');
    $('body').removeClass('modal-open');
    $('.modal-backdrop').remove();

  }
  ngOnChanges() {
    if(this.request?.request_type == "change_school_request"){
      this.gradeId = this.request?.change_school_requests[0]?.to_class?.grade_id;
    }
    else{
      this.gradeId = this.request?.class?.grade_id;
    }
    if (this.gradeId) {
      this.getClassList();
    }
  }

  ngOnDestroy() {
    this.errorMsgService.setMessage(null);
  }

  checkName() {
    const regex = '^[a-zA-Z ^[\u0621-\u064A\u0660-\u0669 ]+$]*$';
    this.foundError = this.name.match(regex);
  }

  takeAction(value, id , cardType , request) {    
    switch (cardType) {
      case "pending":
        
        // check if no grade or class is selected while approving switch to edit mode and return (this guides the user to choose a grade and class)
        // change school requests hold the target class on the request itself, not on the student
        let targetClass = request?.request_type == "change_school_request"
          ? request?.change_school_requests[0]?.to_class
          : request?.class;
        if (value && (!targetClass || !targetClass?.grade)) {
          this.editFlag = true;
          return;
        }
        let body = {
          "is_accepted": value,
          "student_id": this.request.id,
          "user_id": id,
          "request_type": request?.request_type
        };
        
        this.requestsService.takeAction(body).subscribe(res => {
          this.return.emit({action:"reload",id:this.request.id});
          this.showFlag =false;
        },err=>{
          this.errorMsgService.setMessage(err?.error?.message);
        });
        break;
        case "edit":
          switch (value) {
            case true:
              this.requestsService.approveEditRequest(id).subscribe(res =>{
                    this.return.emit({action:"reload",id:id});
                  },err=>{
                    this.errorMsgService.setMessage(err?.error?.message);
                  })
              break;
              case false:
              this.requestsService.cancelEditRequest(id).subscribe(res =>{
                    this.return.emit({action:"reload",id:id});
                  },err=>{
                    this.errorMsgService.setMessage(err?.error?.message);
                  })
              break;
              case 'edit':
                // this.requestsService.setRequestCardData(this.request);
                this.editCard.emit(this.request);
                setTimeout(() => {
                  $("#editCard").modal("show");
                }, 1000);
              break;
          
          }
          // if(is_accepted){
          //   this.requestsService.approveEditRequest(id).subscribe(res =>{
          //     this.return.emit({action:"reload",id:id});
          //   },err=>{
          //     this.errorMsgService.setMessage(err?.error?.message);
          //   })
          // }
          // else{
          // this.requestsService.cancelEditRequest(id).subscribe(res =>{
          //   this.return.emit({action:"reload",id:id});
          // },err=>{
          //   this.errorMsgService.setMessage(err?.error?.message);
          // })
          // }

        break;
          case"early-dismissal":
          switch (value) {
            case true:
              this.requestsService.approveEarlyDismissalRequest(id).subscribe(res =>{
                    this.return.emit({action:"reload",id:id});
                  },err=>{
                    this.errorMsgService.setReloadOnClose(true);
                    this.errorMsgService.setMessage(err?.error?.message);
                  })
              break;
              case false:
                setTimeout(() => {
                  this.earlyDismissalRequest.emit(this.request);
                  $("#declineEarlyDismissal").modal("show");
                }, 100);
              break;
          }
          break;
      default:
        break;
    }
  
  }

  editStudent() {
    this.editFlag = true;
    this.getClassList(true);
  }

  saveStudent(request) {
    switch (request?.request_type) {
      case 'parent_request':
        this.editStudentInfoPendingRequest();
        break;

        case 'change_school_request':
        this.editStudentInfoChangeSchoolRequest(request);
        break;
    
      default:
        break;
    }
  }

  editStudentInfoPendingRequest(){
      // [disabled]="foundError === null ? 'true' : false"
      let body = {
        name: this.name,
        grade_id: this.gradeId,
        class_id: this.classId
      };
    if (this.foundError === null) {
      if (this.name === "" || this.name.length === 0) {
        this.snackBar.setSnackBarMessage(this.translate.instant('user-management.pending-requests.name-empty'));
        this._snackBar.openFromComponent(SnackBarErrorComponent, {
          duration: 5000,
          horizontalPosition: 'center',
          verticalPosition: 'top',
        });
      }
      else {
        this.snackBar.setSnackBarMessage(this.translate.instant('user-management.error-msgs.special-char'));
        this._snackBar.openFromComponent(SnackBarErrorComponent, {
          duration: 5000,
          horizontalPosition: 'center',
          verticalPosition: 'top',
        });
      }
    }
    else {
      let body = {
        name: this.name,
        grade_id: this.gradeId,
        class_id: this.classId
      };
      this.studentService.updateStudent(this.request.id, body).subscribe(res => {
        this.editFlag = false;
        this.request.name = body.name;
        this.request.class_id = body.class_id;
        this.request.class = this.classList.find(clazz => clazz.id == body.class_id);
        this.request.class.grade_id = body.grade_id;
        this.request.class["grade"] = this.grades.find(grade => grade.id == body.grade_id);
      });
    }
  }

  editStudentInfoChangeSchoolRequest(request){
    let body = {
      school_id: localStorage.getItem('schoolId'),
      class_id: this.classId
    };
    this.studentService.updateStudentInChangeSchoolRequest(request?.change_school_requests[0]?.student_id, body).subscribe(res => {
      this.editFlag = false;
      this.request.change_school_requests[0].to_class_id = body.class_id;
      this.request.change_school_requests[0].to_class = this.classList.find(clazz => clazz.id == body.class_id);
      this.request.change_school_requests[0].to_class.grade_id = this.gradeId;
      this.request.change_school_requests[0].to_class["grade"] = this.grades.find(grade => grade.id == this.gradeId);
    });
  }

  cancelEdit(){
    this.editFlag = false;
  }
  getClassList(initFlag = false) {
    if (this.grades != null) {
      // this.classId = null;
      let grade = this.grades.find(grade => grade.id == this.gradeId);
      this.classList = grade.school_classes;
      if (initFlag) {
        this.classId = this.classList.length ? this.classList[0].id : null;
      }
      else{
        if(this.request?.request_type == "change_school_request"){
          this.classId = this.request?.change_school_requests[0]?.to_class?.id;
        }
        else{
          this.classId = this.request.class_id;
        }
      }
    }
  }

  getImage(imagePath: string) {
    return environment.img_url + imagePath;
  }

  deliverEarlyDismissalRequestStudent(id, requestType, request) {
    this.requestsService.deliverEarlyDismissalRequestStudent(id).subscribe(res => {
      this.return.emit({action:"reload",id:id});
    },err=>{
      this.errorMsgService.setReloadOnClose(true);
      this.errorMsgService.setMessage(err?.error?.message);
    });
  }
}
